module.exports = __webpack_public_path__ + "assets/img/extractionTarot_Tit.98e493ce.png";